<template>
  <div>
    <h1>Novo plano</h1>
    <b-card>
      <Form @saved="loadData" />
    </b-card>
  </div>
</template>

<script>
import Form from "../Components/Form.vue";
import { mapState, mapActions } from "vuex";

export default {
  components: { Form },
  computed: {
    ...mapState("planos", ["plano"]),
  },
  methods: {
    ...mapActions("planos", ["ActionNewplano"]),
    loadData(id) {
      this.$router.push({ name: "planos_edit", params: { id: id } });
    },
  },
  async created() {
    this.ActionNewplano();
  },
};
</script>

<style></style>
